<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div :key="loading">

        <div class="row m-0 d-print-none">
          <div class="button-pills col-xs-12 col-md-5 col-xl-4 py-2 bg-white" style="border-radius: 5px">
            <pill-button
                v-model="activePillButton"
                :first-button="pillButton.first"
                :second-button="pillButton.second"
                :third-button="pillButton.third"
            ></pill-button>
          </div>
          <div v-if="activePillButton === 'resume'" class="col-xs-12 col-md-7 col-xl-8">
            <div class="d-flex justify-content-end" style="width: 100%" v-if="!denyExport">
              <div class="me-2" style="width: 114px">
                <div class="pb-2" style="font: 700 12px/14px Lato">Lihat sebagai</div>
                <b-form-select v-model="activeRoleButton" :options="viewAsOptions"></b-form-select>
              </div>
              <div class="d-flex align-items-end">
                <b-button :disabled="loadingExport" class="btn btn-block btn-export-resume"
                          @click="onClickExportResume">
                  <i v-if="loadingExport" class="bx bx-loader-circle"></i>
                  <i v-else class="bx bxs-download"></i>
                  Resume {{ lodash.upperFirst($t(`${activeRoleButton}s.singular`)) }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <component
              v-bind:is="activeShowComponent"
              :key="`show-${activeRoleButton}-${Object.keys(model).length}}-${exportItems.join(',')}`"
              v-model="model"
              :active-tab="activeRoleButton"
              :export-items="selectedExportItems"
          />
        </div>
        <modal-resume-export
            id="export-resume-modal"
            :key="`modal-export-${exportItems.length}`"
            v-model="selectedExportItems"
            :items="exportItems"
            v-on:cancel="hidePrintModal"
            v-on:print="handlePrint"
        />
      </div>
    </Loader>
  </Layout>
</template>
<script>
import Loader from '@/components/widgets/loader';
import ModelShow from '../models/show';
import PillButton from './show/pill-button'
import Row from '@/components/models/show/custom-row';
import Detail from './show/detail';
import Invoice from './show/invoice'
import ResumeV2 from './show/resume-v2'
import Swal from 'sweetalert2'
import ModalResumeExport from '@/components/modals/modal-resume-export'

export default {
  extends: ModelShow,
  page: {
    title: "Detail Sale Notes",
  },
  components: {
    Loader,
    PillButton,
    Detail,
    ResumeV2,
    ModalResumeExport,
    // Resume
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t('sale_notes.singular'))
      }
    },
    resourceRoute: {default: 'sale_notes'},
    modelVariable: {default: 'sale_note'},
    denyDelete: {type: Boolean, default: true},
    denyEdit: {
      type: Boolean, default() {
        return !this.$auth.hasJalaTradeRole(['admin', 'finances'])
      }
    },
    denyExport: {default() {
      return !this.$auth.hasPermissionTo("sale_reports.export")
    }},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
    cardAttrs: {
      default() {
        return {
          class: 'card-plain',
          style: {marginBottom: 0, padding: 0, overflow: 'hidden', height: '491px', overflowY: 'auto'},
          noBody: true,
          'data-simplebar': true,
          'data-simplebar-auto-hide': "false"
        }
      }
    },
  },
  data() {
    return {
      loadingExport: false,
      title: this.lodash.startCase(this.$t('sale_notes.plural')),
      activePillButton: null,
      pillActiveIndex: 0,
      pillButton: {
        first: {
          value: 'detail',
          label: this.lodash.upperFirst(this.$t('sale_notes.shows.detail'))
        },
        second: {
          value: 'resume',
          label: this.lodash.upperFirst(this.$t('sale_notes.shows.resume'))
        },
        third: {
          value: 'invoice',
          label: this.lodash.startCase(this.$t('sale_notes.shows.sales_invoice'))
        }
      },
      activeRoleButton: 'partner',
      selectedExportItems: [],
      exportItems: [],
      viewAsOptions: [
        {value: 'admin', text: this.lodash.upperFirst(this.$t('admins.singular'))},
        {value: 'partner', text: this.lodash.upperFirst(this.$t('partners.singular'))},
      ]
    }
  },
  computed: {
    isJalaHarvest() {
      return this.model?.trip?.trip_items?.[0]?.purchase_item?.purchase_order?.type === 'harvest'
    },
    resumeFilename() {
      if (this.selectedExportItems.length > 1) {
        let date = this.model.is_unload_order ? this.model?.ordered_at : this.model?.purchase_order?.ordered_at
        return `Resume ${this.uniquePurchaseOrders.map(({customer: {name}}) => name).join(', ')} ${this.$moment.utc(date).local().format('DD MMMM YYYY')}`
      }

      let item = this.selectedExportItems[0]
      let {name = ''} = this.exportItems.find(({value}) => value === item) ?? {}
      let date = null
      let filename = `${this.lodash.startCase(name.toLowerCase())} ${this.uniquePurchaseOrders.map(({customer: {name}}) => name).join(', ')}`
      if (item === 'purchase_order') {
        date = this.model?.type === 'brs' ? this.model?.purchase_order?.ordered_at : this.model?.sale_items[0]?.purchase_order?.ordered_at
      } else if (item === 'trip') {
        date = this.model?.trip?.tripped_at
      } else if (item === 'delivery_order') {
        date = this.model?.delivery_order?.ordered_at
      } else if (['unload', 'balance', 'note'].includes(item)) {
        date = this.model?.ordered_at
      } else if (item === 'sale_payment') {
        date = this.model?.payments[0]?.paid_at
      }
      return date ? `${filename} ${this.$moment.utc(date).local().format('DD MMMM YYYY')}` : filename
    },
    activeShowComponent() {
      if (this.activePillButton === 'resume') return ResumeV2
      if (this.activePillButton === 'invoice') return Invoice
      return Detail
    },
    uniquePurchaseOrders() {
      if (!this.model?.sale_items) return []
      let purchaseOrders = this.model.sale_items.filter(({purchase_order}) => purchase_order).map(({purchase_order}) => purchase_order)
      return this.lodash.uniqBy(purchaseOrders, 'id')
    }
  },
  created() {
    this.setInitialActivePillButton()
  },
  mounted() {
    this.fetchModel();
  },
  methods: {
    onClickExportResume() {
      if (this.activeRoleButton === 'partner') {
        return this.handlePartnerExportResume()
      }
      this.$bvModal.show('export-resume-modal')
    },
    handlePartnerExportResume() {
      this.loadingExport = true;
      return this.$axios.get(`/sale_orders/${this.model.id}/sale_resume_export`, {
        responseType: "blob",
      }).then(res => {
        const href = URL.createObjectURL(res.data);
        const link = document.createElement("a");
        let supplierName = [...new Set(this.model.sale_items.map(item => item.purchase_order?.customer?.name))]
            .sort()
            .join("_")
        link.href = href;
        const folderId = this.model.ticketable?.ticket_id ?? this.model.sales_plan_id ?? this.model.id
        link.setAttribute(
            "download",
            `${folderId}_${supplierName}_${this.model.ordered_at}_${this.model.customer.name} .pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        return res;
      })
          .catch(() => {
            return Swal.fire({
              title: this.lodash.startCase(this.$t("failed")),
              text: this.lodash.upperFirst(this.$t("download_failed")),
              type: "danger",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          })
          .finally(res => {
            this.loadingExport = false;
            return res;
          });
    },
    resumeExportItems(isUnloadOrder) {
      if (!isUnloadOrder) return [
        {value: 'purchase_order', name: this.lodash.upperCase(this.$t('purchase_orders.singular')), $checked: false},
        {value: 'sale_payment', name: this.lodash.upperCase(this.$t('sale_invoices.singular')), $checked: false},
        {value: 'note', name: this.lodash.upperCase(this.$t('sale_notes.resumes.note')), $checked: false},
      ]

      let items = [
        {value: 'trip', name: this.lodash.upperCase(this.$t('trips.singular')), $checked: false},
        {value: 'unload', name: this.lodash.upperCase(this.$t('unloads.singular')), $checked: false},
        {value: 'sale_payment', name: this.lodash.upperCase(this.$t('sale_invoices.singular')), $checked: false},
        {value: 'balance', name: this.lodash.upperCase(this.$t('sale_notes.resumes.balancing')), $checked: false},
        {value: 'note', name: this.lodash.upperCase(this.$t('sale_notes.resumes.note')), $checked: false},
      ]
      if (this.isJalaHarvest) {
        items = items.filter(item => item.value !== 'balance')
      }
      return items;
    },
    handlePrint() {
      let onlySalePayment = this.selectedExportItems.length === 1 && this.selectedExportItems[0] === 'sale_payment'
      let doesntHavePayment = !this.model?.payments?.length ?? 0
      if (onlySalePayment && doesntHavePayment) {
        return Swal.fire({
          title: this.$t('Warning') + '!',
          text: this.lodash.upperFirst(this.$t('sale_notes.resumes.validations.there is no sale payment data', {
            something: this.exportDatesLabel
          })),
          type: 'warning',
          confirmButtonClass: 'btn btn-warning btn-fill',
          buttonsStyling: false
        })
      } else {
        document.title = this.resumeFilename
        window.print()
      }
    },
    hidePrintModal() {
      this.$bvModal.hide('export-resume-modal')
    },
    update(value) {
      return this.$axios.put(`/sale_orders/${this.$route.params.key}`, value)
    },
    onClickRoleButton(value) {
      this.$set(this, 'activeRoleButton', value)
    },
    pills() {
      return [
        {
          label: 'Detail',
          active: (this.pillActiveIndex === 0),
          onClick: () => this.pillActiveIndex = 0
        },
        {
          label: 'Resume',
          active: (this.pillActiveIndex === 1),
          onClick: () => this.pillActiveIndex = 1
        },
      ]
    },
    delete() {
      return this.$axios.delete(`/sale_orders/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/v2/sale_orders/${this.$route.params.key}`, {
        params: {
          include: [
            "balancing_transaction",
            "creator",
            "customer.addresses",
            "files",
            "profit_share",
            "sale_additional_items",
            "sale_items.trip_items.purchase_item",
            "sale_items.trip_items.purchase_order.customer",
            "sale_items.trip_items.purchase_order.product",
            "sales_invoice",
            "sales_plan.product",
            "sales_reports.sales_reportable",
            "ticketable.ticket",
            "trip.customer",
            "trip.driver",
            "trip.purchase_order",
            "trip.trip_items.purchase_item.purchase_order.customer",
            "trip.vehicle",
          ].join(','),
        }
      }).then((response) => {
        let {data: {data}} = response;
        this.exportItems = this.resumeExportItems(data.is_unload_order)

        this.model = {
          ...data,
          additional_fees: data.sale_additional_items.filter(item => item.total > 0),
          discounts: data.sale_additional_items.filter(item => item.total < 0),

        };
        return response;
      }).catch((error) => this.failedAlert(error))
          .finally(() => this.loading = false)
    },
    setInitialActivePillButton() {
      if (this.$route.query.section === 'balancing') this.activePillButton = 'resume'
      else if (this.$route.query.redirectTo === 'invoice') this.activePillButton = 'invoice'
      else if (this.$route.query.redirectTo === 'resume') this.activePillButton = 'resume'
      else this.activePillButton = 'detail'
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-export-resume {
  font: 700 14px/16px Lato;
  padding: 8px;
  border-radius: 5px;
  background: #1DA62B;
  color: white;
  border-color: #1DA62B;
  width: 132px;
}

.role-nav {
  background: #EEF3F7;
  color: #6C7589 !important;
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: center;
  border-radius: 0;
  padding-bottom: 16px;
}

.role-nav.active {
  color: #0084F3 !important;
  border-bottom: 2px solid #0084F3;
  padding-bottom: 14px;
}

::v-deep {
  .preloader-component {
    background-color: #FFFFFF;
  }

  .container-title {
    color: #6C7589;
    margin-top: 10px;
    font-family: Lato;
    font-size: 12px;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.05em;
    text-align: left;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  .text-success {
    color: #1DA62B;
  }

  .text-danger {
    color: #F83A11;
  }

  .export {
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0em;

    .container-title {
      background-color: #0084F3;
      margin: 0;
      padding: 8px 16px;
      border: 1px solid #0084F3;
      color: white;

      font-size: 12px;
      font-weight: 700;
      line-height: 14px;
      letter-spacing: 0em;

    }

    .card {
      border: 1px solid #DBDBE7;
      border-bottom: 0 !important;
      margin: 0;
      box-shadow: none;

      .card-body {
        background-color: #EFF7FF;
      }
    }

    table {
      border: 1px solid #DBDBE7;
      border-top: 0 !important;
      margin: 0;

      th {
        color: #6C7589;
      }

      th, td {
        padding: 6px 16px;
        background-color: #EFF7FF;

        b {
          font-weight: 700;
        }
      }
    }
  }
}

.custom-group {
  margin-bottom: 30px;
}

.custom-label, .custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label {
  font-weight: 700;
  color: #161B4D;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.custom-text {
  font-weight: 400;
}

.section-title {
  background-color: #F9FAFB;
  color: #161B4D;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ECECF2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label, .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161B4D;
    font-weight: 400;
  }

  .section-value {
    color: #161B4D;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161B4D;
  background-color: #F9FAFB;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161B4D;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #EEF3F7;
}

@media print {
  ::v-deep .page-content {
    background: #fff;
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}

.button-export {
  .dropdown {
    ul.dropdown-menu.show {

    }
  }
}
</style>